/**
 * Created by Daniela on 29/09/2016.
 */
import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[contaContabilCodigoMask]'
})
export class ContaContabilCodigoMaskDirective {
    constructor(
        public model: NgControl
    ) {}

    @HostListener('ngModelChange') ngModelChange() {
        this.modelValue();
    }

    @HostListener('keydown.backspace') onKeyDownBackspace() {
        this.modelValue(true);
    }

    private modelValue(backspace?: boolean) {
        if (this.model) {
            var model: any = this.model;
            if(model.viewModel) {
                if (typeof model.viewModel === 'number') {
                    model.viewModel = model.viewModel.toString();
                }
                this.inputChange(model.viewModel, backspace);
            }
        }
    }

    private inputChange(model: any, backspace?: any) {
        if (model) {
            var newVal = model.replace(/\D/g, '');

            if(backspace) {
                if(newVal.length === 1){
                    newVal = newVal.substring(0, newVal.length - 1);
                }
            }

            if (newVal.length == 0) {
                newVal = '';
            } else if (newVal.length === 1) {
                newVal = newVal.replace(/(\d{1})/, "$1.");
            } else if (newVal.length <= 2) {
                newVal = newVal.replace(/(\d{1})(\d{1})/, "$1.$2");
            } else if (newVal.length <= 3) {
                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})/, "$1.$2.$3");
            } else if (newVal.length <= 4) {
                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})/, "$1.$2.$3.$4");
            } else if (newVal.length <= 5) {
                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})/, "$1.$2.$3.$4.$5");
            } else if (newVal.length <= 7) {
                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{0,2})/, "$1.$2.$3.$4.$5.$6");
            } else if (newVal.length <= 9) {
                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{0,2})(\d{0,2})/, "$1.$2.$3.$4.$5.$6.$7");
            }

            this.model.valueAccessor.writeValue(newVal);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/directives/conta-contabil-codigo-mask.directive.ts
 **/